import { render, staticRenderFns } from "./drawable-area.vue?vue&type=template&id=4a582466"
import script from "./drawable-area.vue?vue&type=script&lang=js"
export * from "./drawable-area.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports